import './navbar.css'
import DropDown from './DropDown'
import { Link } from 'react-router-dom'
import React from 'react'

function Navbar() {

  const appl = [
    { path: '/merge-tool', title: 'Merge Tool' },
    { path: '/sync-appl-status', title: 'Sync Applicant Status' },
  ]

  const client = [
    { path: '/client-config-tool', title: 'Configuration' },
    { path: '/hide-eed-fields', title: 'Hide EED Fields' },
    { path: '/power-extensions', title: 'Power Extensions' }, 
  ]

  const imagesUrl = process.env.REACT_APP_IMAGES_URL

  return (
    <>
      <section>
        <nav className="navbar">
          <Link className="logo" to="/">
            <img
              alt="talentReef"
              className="logo-icon"
              src={`${imagesUrl}/logo/white-1000x476.png`}
            />
          </Link>

          <ul className="nav-side-menu">
            <li className="nav-items">
              <Link className="nav-links" to="/">
                {' '}
								Home{' '}
              </Link>
            </li>

            <li
              className="nav-items"
            >
              <DropDown menuItems={appl} >
                Applicant Support <i className="fas fa-caret-down" />
              </DropDown>
            </li>

            <li
              className="nav-items"
            >
              <DropDown menuItems={client} >
                Client <i className="fas fa-caret-down" />
              </DropDown>
            </li>
          </ul>
        </nav>
      </section>
    </>
  )
}

export default Navbar